<xpo-icon *ngIf="shouldDisplayIcon()" style="height:25px" [iconName]="iconName"></xpo-icon>
